export const ClockingSectionWrapperStyle = (theme: any) => ({
  boxSizing: "border-box",
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  width: "216px",
  minHeight: "72px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  p: "12px 14px",
  gap: "14px",
  flexShrink: 0,
});
export const flexColumnFlexStart = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

export const flexRowFlexEnd = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
};

export const flexRowCenter = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  p: "0px",
};
export const headingStyle = (theme: any) => ({
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "var(--wo-dialog-heading-size, 14px)",
  lineHeight: 1.25,
  color: theme.palette.text.primary,
});
export const normalStyle = (theme: any) => ({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "var(--wo-dialog-font-size, 14px)",
  lineHeight: 1.25,
  color: theme.palette.text.primary,
});
export const progressBarWrapperStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  zIndex: 9999, // Very high z-index to cover everything
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
  backdropFilter: "blur(2px)", // Add blur effect for better UX
};
export const woDocNumberStyle = (theme: any) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "var(--wo-dialog-title-size, 21px)",
  lineHeight: 1.4,
  color: theme.palette.text.primary,
});
export const createdByStyle = (theme: any) => ({
  fontStyle: "normal",
  fontSize: "15px",
  lineHeight: "32px",
  color: theme.palette.text.primary,
});
export const poNumberStyle = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "15px",
  color: "#1F292E",
};

export const clockingLabelStyle = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "17px",
  color: "#5C6970",
};

export const iconStyle = {
  backgroundColor: "#2371E7",
  color: "white",
};
